/**
 * @prettier
 */
export const SalesTypes = {
    NET_SALES: 'NET_SALES',
    GROSS_SALES: 'GROSS_SALES',
} as const;

export type SalesType = typeof SalesTypes[keyof typeof SalesTypes];
